export default {
  apiKey: "AIzaSyAmd-bZ4xg0H82YlmESshWTCEWJEq1vzQ8",
  authDomain: "mathpro-11cdf.firebaseapp.com",
  databaseURL: "https://mathpro-11cdf.firebaseio.com",
  projectId: "mathpro-11cdf",
  storageBucket: "mathpro-11cdf.appspot.com",
  messagingSenderId: "904271726833",
  appId: "1:904271726833:web:80b3697a69a28b3d8c0150",
  measurementId: "G-59VZ6TWMK0"
};